<template lang="pug">
//- Two-column editorial layout: sticky side rail (outline / meta / filters) + reading column.
//- Uses the full editorial width; collapses to one column under 992px.
.rail-layout(:class="{ 'rail-layout--wide-main': wideMain }")
  aside.rail-side(v-if="$slots.side")
    slot(name="side")
  .rail-main
    slot
</template>

<script>
export default {
  name: 'RailLayout',
  props: {
    // Let the main column grow to the full remaining width (lists) instead of the reading measure (prose)
    wideMain: { type: Boolean, default: false },
  },
}
</script>

<style lang="sass">
.rail-layout
  width: var(--editorial-w, min(92vw, 1560px))
  margin: 0 auto
  padding: 40px 0 80px
  display: grid
  grid-template-columns: var(--side-w, 300px) minmax(0, 1fr)
  gap: 64px
  align-items: start
  text-align: left

  .rail-side
    position: sticky
    top: 84px
    max-height: calc(100vh - 100px)
    overflow-y: auto
    padding-right: 6px
    scrollbar-width: thin
    display: flex
    flex-direction: column
    gap: 18px

  .rail-main
    max-width: var(--reading-w, 960px)
    min-width: 0

  &.rail-layout--wide-main .rail-main
    max-width: none

  @media (max-width: 991px)
    grid-template-columns: 1fr
    gap: 28px
    padding-top: 24px
    .rail-side
      position: static
      max-height: none
      overflow: visible
    .rail-main
      max-width: none
</style>
